<template>
  <div class="forms-page answer-page" dir="rtl">
    <div class="forms-hero">
      <div class="answer-hero-main">
        <p class="hero-kicker mb-1">پاسخ‌نامه فرم</p>
        <h1 class="mb-0">{{ form.name || '...' }}</h1>
        <div class="answer-hero-chips">
          <span class="answer-hero-chip">#{{ formFill.id || formFillId }}</span>
          <span v-if="formFill.status !== undefined && formFill.status !== null"
                class="answer-hero-chip" :class="statusClass">{{ statusLabel }}</span>
          <span v-if="formFill.created_at" class="answer-hero-chip" dir="ltr">
            {{ dateConverter(formFill.created_at, '/', true) }}
          </span>
        </div>
      </div>
      <div class="hero-side">
        <div class="hero-count" v-if="hasScore">
          <strong>{{ formFill.score }}</strong>
          <span>امتیاز</span>
        </div>
        <div class="hero-count">
          <strong>{{ answerItems.length }}</strong>
          <span>پاسخ</span>
        </div>
        <div class="hero-badge">
          <b-icon icon="file-earmark-text"></b-icon>
        </div>
      </div>
    </div>

    <div class="forms-toolbar">
      <div class="forms-toolbar-actions">
        <router-link v-if="form.id" class="forms-tool-btn" :to="{ name: 'FormFills', params: { id: form.id } }">
          <b-icon icon="arrow-right"></b-icon>
          <span>پاسخ‌های این فرم</span>
        </router-link>
      </div>
      <div class="forms-toolbar-actions">
        <button type="button" @click="redirectToSiteForm" class="forms-tool-btn">
          <b-icon icon="box-arrow-up-left"></b-icon>
          <span>مشاهده فرم در سایت</span>
        </button>
        <button type="button" @click="sendNotificationMessageForUser" class="forms-tool-btn is-primary">
          <b-icon icon="bell"></b-icon>
          <span>ارسال پیام اطلاعیه به کاربر</span>
        </button>
      </div>
    </div>

    <div class="answer-layout">
      <div class="answer-main">
        <section class="answer-card">
          <div class="answer-card-head">
            <h2>پاسخ‌ها</h2>
            <span class="form-id-chip">{{ answerItems.length }} مورد</span>
          </div>

          <div v-if="!answerItems.length" class="forms-empty">
            <b-icon icon="inbox"></b-icon>
            <span>برای این پاسخ‌نامه هنوز پاسخی ثبت نشده است.</span>
          </div>

          <div v-else class="answer-list">
            <template v-for="row in answerItems">
              <div v-if="row.type === 'step'" :key="row.answer.id" class="answer-step">
                <b-icon icon="signpost-split"></b-icon>
                <span>{{ row.title }}</span>
              </div>

              <article v-else :key="row.answer.id" class="answer-item">
                <div class="answer-item-head">
                  <div class="answer-question">
                    <span class="answer-num">{{ row.number }}</span>
                    <span>{{ row.title }}</span>
                  </div>
                  <div class="answer-item-tools">
                    <span class="answer-id">#{{ row.answer.id }}</span>
                    <button type="button" class="form-action" title="ویرایش پاسخ"
                            v-b-modal="`edit-answer-${row.answer.id}`"
                            v-if="row.question?.config?.only_admin_edit == true && isAdmin">
                      <b-icon icon="pen"></b-icon>
                    </button>
                  </div>
                </div>

                <div class="answer-value">
                  <template v-if="row.type == 'category_input'">
                    <form-category-answer :answer="row.resolved"/>
                  </template>
                  <template v-else-if="row.type == 'choose_product_input'">
                    <form-choose-product-input-answer :answer="row.resolved"/>
                  </template>
                  <template v-else-if="row.type == 'choose_multiple_product_input'">
                    <form-choose-multiple-product-input-answer :answer="row.resolved"/>
                  </template>
                  <template v-else-if="row.type == 'create_shopping_cart_input'">
                    <span dir="ltr">{{ dateConverter(row.answer.created_at, '/', true) }}</span>
                  </template>
                  <template v-else-if="row.html">
                    <span v-html="row.html"></span>
                  </template>
                  <span v-else class="answer-empty">بدون پاسخ</span>
                </div>

                <b-modal :id="`edit-answer-${row.answer.id}`" hide-footer>
                  <form @submit.prevent="submitAnswerForm(row.answer, row.index)">
                    <div class="text-right" dir="rtl">
                      <label>
                        ویرایش پاسخ:
                        {{ row.title }}
                      </label>
                      <input class="form-control" type="text" v-model="answers[row.index].answer">
                    </div>
                    <div class="col-12 my-2">
                      <div class="row text-center">
                        <button class="btn col-12 btn-primary">ثبت</button>
                      </div>
                    </div>
                  </form>
                </b-modal>
              </article>
            </template>
          </div>
        </section>
      </div>

      <aside class="answer-side">
        <section class="answer-card">
          <div class="answer-card-head">
            <h2>پاسخ‌دهنده</h2>
          </div>
          <div class="answer-user">
            <div class="answer-avatar">
              <b-icon icon="person-fill"></b-icon>
            </div>
            <div class="answer-user-info">
              <strong>{{ user.name }} {{ user.last_name }}</strong>
              <span v-if="user.cellphone" dir="ltr">{{ user.cellphone }}</span>
            </div>
          </div>
          <router-link v-if="user.id" target="_blank" class="form-action answer-side-btn"
                       :to="{ name: 'UpdateUser', params: { id: user.id } }">
            <b-icon icon="person-badge"></b-icon>
            <span>مشاهده پروفایل</span>
          </router-link>
        </section>

        <section class="answer-card">
          <div class="answer-card-head">
            <h2>وضعیت و توضیحات</h2>
          </div>
          <form @submit.prevent="sendFormDescription">
            <div class="form-group">
              <label>وضعیت فرم</label>
              <select :disabled="!isAdmin" class="custom-select" v-model="formFillDescription.status">
                <option v-for="(item,index) in form_fill_status" :value="index">{{ item }}</option>
              </select>
            </div>

            <div class="form-group" v-if="getFormType(form.form_questions) == 'step'">
              <label>مرحله فرم</label>
              <select :disabled="!isAdmin" class="custom-select" v-model="formFillDescription.step">
                <option v-for="(item,index) in extractFormSteps(form.form_questions)" :value="index">{{ item.title }}</option>
              </select>
            </div>

            <div class="form-group">
              <label for="exampleFormControlTextarea1">توضیحات</label>
              <textarea minlength="1" v-model="formFillDescription.description" :disabled="!isAdmin" class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"></textarea>
            </div>

            <button type="submit" class="form-action is-main answer-side-btn" v-if="isAdmin">
              <b-icon icon="check2"></b-icon>
              <span>ثبت</span>
            </button>
          </form>
        </section>

        <section class="answer-card" v-if="isAdmin">
          <div class="answer-card-head">
            <h2>چت با کاربر</h2>
          </div>
          <chat-form v-if="formFillChatSlug() == false && isAdmin" class="form-answer-chat-form"
                     :submit-function="startNewChatWrapper"/>
          <div v-if="formFillChatSlug() != false">
            <m-a :href="formFillChatSlug()" target="_blank">
              <span class="form-action is-main answer-side-btn">
                <b-icon icon="chat-dots"></b-icon>
                <span>مشاهده چت</span>
              </span>
            </m-a>
          </div>
        </section>
      </aside>
    </div>
  </div>
</template>

<script>
import {
  convertCategoryInputValueToNames,
  extractFormSteps,
  form_fill_status,
  formAnswer,
  formAnswerManager,
  formQuestion,
  getFormType
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Form";
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import ChatForm from "@/plugin/components/dashboard/Chat/ChatForm.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import FormCategoryAnswer from "./FormCategoryAnswer.vue";
import FormChooseProductInputAnswer from "./FormChooseProductInputAnswer.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import FormChooseMultipleProductInputAnswer from "./FormChooseMultipleProductInputAnswer.vue";
import "./forms-ui.css";


export default {
  name: "FormAnswer",
  components: {FormChooseMultipleProductInputAnswer, FormChooseProductInputAnswer, FormCategoryAnswer, ChatForm},
  data() {
    return {
      form_fill_status,
      answers: [],
      formFill: {},
      form: {},
      user: {},
      formFillMeta: {},
      formFillDescription: {
        description: null,
        step: null,
        status: null,
      },
      categoryAnswer:''
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
      adminProfile: "User/getProfile"
    }),
    formFillId() {
      return this.$route.params.form_fill
    },
    statusLabel() {
      const status = this.formFill.status
      const label = form_fill_status[Number(status)]
      return label !== undefined ? label : `وضعیت ${status}`
    },
    statusClass() {
      const status = Number(this.formFill.status)
      if (status === 0) {
        return 'is-waiting'
      }
      if (status === 3) {
        return 'is-done'
      }
      return ''
    },
    hasScore() {
      const score = this.formFill.score
      return score !== null && score !== undefined && score !== ''
    },
    answerItems() {
      if (!Array.isArray(this.answers)) {
        return []
      }
      let number = 0
      return this.answers.map((answer, index) => {
        const question = formQuestion(this.form, answer.form_item_id)
        const resolved = formAnswer(this.form, answer.form_item_id, answer)
        const type = resolved ? resolved.type : (question ? question.type : '')
        const value = resolved ? resolved.label : answer.answer
        const isEmpty = value === null || value === undefined || String(value).trim() === ''
        if (type !== 'step') {
          number++
        }
        return {
          answer,
          index,
          question,
          resolved,
          type,
          number,
          title: (question && question.title) || `سوال ${answer.form_item_id}`,
          html: isEmpty ? '' : formAnswerManager(resolved || {label: value, type})
        }
      })
    },
  },
  methods: {
    dateConverter,
    formAnswerManager,
    formAnswer,
    formQuestion,
    setFormFillDescription(baseData) {
      let formFill = baseData.formFill
      let metas = baseData.formFillMeta

      metas.forEach(item => {
        if (item.name == 'form-fill-description') {
          this.formFillDescription.description = item.value
        }
      })

      this.formFillDescription.status = formFill.status
      this.formFillDescription.step = baseData.form_step
    },
    getAnswerData() {
      let form = {
        user_id: this.$route.params.user,
        form_fill_id: this.$route.params.form_fill,
      }
      let req = this.$store.dispatch('Form/getFormAnswer', form)
      req.then(res => {
        let baseData = res.data.data

        this.answers = baseData.answers
        this.form = baseData.form
        this.user = baseData.user
        this.formFill = baseData.formFill
        this.formFillMeta = baseData.formFillMeta
        this.setFormFillDescription(baseData)
        if (this.isAdmin) {
          this.$store.dispatch('FormSeen/fetchUnseenCount', {force: true})
        }
      })
    },
    sendFormDescription() {
      let form = Object.assign({}, this.formFillDescription)
      form['id'] = this.$route.params.form_fill
      this.$store.dispatch("Form/setDescriptionOfFormFill", form).then(res => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.', 'success')
      })
    },
    storeChatLink(chatLink) {
      let form = {
        "name": 'form_fill_chat_link',
        "value": chatLink,
        "metable_type": 'formFill',
        "metable_id": this.formFillId,
        "type": 0,
        "overwrite_preview_value": 0,
      }
      this.$store.dispatch('Meta/createMeta', form).then(res => {
        this.getAnswerData()
      })
    },
    startNewChatWrapper(form) {
      let adminChatToken = this.adminProfile.chat_token
      let userChatToken = this.user.chat_token

      form.withoutState = true

      form.users = [...new Set([adminChatToken, userChatToken])]


      this.$store.dispatch('Chat/startNewChat', form).then(res => {
        let data = res.data.data.data
        let slug = data.slug

        this.storeChatLink(slug)

        let routeData = this.$router.resolve({name: 'SingleChat', params: {slug: slug}});
        window.open(routeData.href, '_blank');

      })
    },
    formFillChatSlug() {
      let result = false
      if (Object.keys(this.formFillMeta).length == 0) {
        return result
      }
      this.formFillMeta.forEach(item => {
        if (item.name == "form_fill_chat_link") {
          result = this.$router.resolve({name: 'SingleChat', params: {slug: item.value}}).href
        }
      })
      return result
    },
    getFormType,
    extractFormSteps,
    submitAnswerForm(answerObject, answerIndex) {


      let form = {
        form_fill_item_value: this.answers[answerIndex].answer,
        form_fill_item_id: answerObject.id,
        form_fill: this.$route.params.form_fill
      }

      this.$store.dispatch('Form/updateFormAnswerFromAdmin', form).then(res => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      })

    },
    sendNotificationMessageForUser() {
      if (confirm('آیا از ارسال اطلاعیه اطمینان دارید؟')) {
        let form = {
          formFill: this.$route.params.form_fill,
        }
        this.$store.dispatch('Form/sendNotificationSmsMessage', form).then(res => {
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }
    },
    redirectToSiteForm() {
      let url = this.$router.resolve({
        name: 'FormAnswer',
        params: {user: this.$route.params.user, form_fill: this.$route.params.form_fill}
      })['href']
      window.open(`${findAttributeOnSiteInfo('site_link')}${url}`, '_blank');
    }
  },
  mounted() {
    this.getAnswerData()


  }
}
</script>

<style scoped>
.answer-hero-main {
  min-width: 0;
}

.answer-hero-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.answer-hero-chip {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border-radius: 999px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
}

.answer-hero-chip.is-waiting {
  background: #fff4e0;
  color: #b26a00;
}

.answer-hero-chip.is-done {
  background: #e6f6ec;
  color: #1e7a3c;
}

.answer-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 16px;
  align-items: start;
}

.answer-side {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: sticky;
  top: 12px;
}

.answer-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 18px;
  padding: 16px;
}

.answer-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}

.answer-card-head h2 {
  font-size: 15px;
  font-weight: 800;
  margin: 0;
  color: #1e1e1e;
}

.answer-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.answer-step {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  padding: 6px 2px;
  color: #eb3d60;
  font-weight: 800;
  font-size: 13px;
  border-bottom: 1px dashed rgba(235, 61, 96, 0.35);
}

.answer-item {
  border: 1px solid #eee;
  border-radius: 14px;
  padding: 12px 14px;
  background: #fcfcfc;
}

.answer-item-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.answer-question {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-weight: 700;
  color: #555;
  font-size: 13px;
  min-width: 0;
  word-break: break-word;
}

.answer-num {
  flex-shrink: 0;
  min-width: 22px;
  height: 22px;
  border-radius: 999px;
  background: #1e1e1e;
  color: #fff;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.answer-item-tools {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.answer-id {
  color: #aaa;
  font-size: 11px;
}

.answer-value {
  margin-top: 8px;
  padding-right: 30px;
  color: #1e1e1e;
  font-size: 14px;
  font-weight: 600;
  word-break: break-word;
  white-space: pre-line;
}

.answer-value ::v-deep img {
  max-width: 180px;
  max-height: 180px;
  border-radius: 12px;
  border: 1px solid #eee;
  background: #fff;
}

.answer-empty {
  color: #aaa;
  font-weight: 400;
  font-style: italic;
}

.answer-user {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.answer-avatar {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: rgba(235, 61, 96, 0.1);
  color: #eb3d60;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.answer-user-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.answer-user-info span {
  color: #888;
  font-size: 12px;
  text-align: right;
}

.answer-side-btn {
  width: 100%;
}

.answer-side label {
  font-size: 12.5px;
  font-weight: 700;
  color: #555;
}

.answer-side .custom-select,
.answer-side .form-control {
  border-radius: 10px;
}

.form-answer-chat-form ::v-deep .chat-form-tags,
.form-answer-chat-form ::v-deep .chat-form-users,
.form-answer-chat-form ::v-deep .chat-form-group,
.form-answer-chat-form ::v-deep .chat-form-files,
.form-answer-chat-form ::v-deep .chat-form-categories {
  display: none;
}

@media (max-width: 991px) {
  .answer-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .answer-side {
    position: static;
  }
}

@media (max-width: 767px) {
  .answer-value {
    padding-right: 0;
  }

  .answer-card {
    padding: 12px;
  }
}
</style>
